import React, { useMemo } from 'react';
import { Box, HStack, VStack, Text, Image, Icon } from '@chakra-ui/react';
import { FiUsers } from 'react-icons/fi';
import { useTranslation } from '../../hooks/useTranslation';
import { useRoomById } from '../../hooks/useRooms';
import LoadingState from '../base/LoadingState';

interface MeetingRoomPreviewProps {
    roomId: number;
}

const MeetingRoomPreview: React.FC<MeetingRoomPreviewProps> = ({ roomId }) => {
    const { t } = useTranslation();
    const { room, isLoading } = useRoomById(roomId);

    if (isLoading) {
        return <LoadingState message={t.pages.support.loading} />;
    }

    if (!room) {
        return null;
    }

    return (
        <Box bg="white" p={4}>
            <HStack gap={4} align="center">
                {/* Картинка */}
                <Box w="120px" h="80px" bg="gray.200" position="relative" overflow="hidden" flexShrink={0}>
                    <Image src={room.image_links[0]} alt={room.name} w="full" h="full" objectFit="cover" />
                </Box>

                {/* Информация */}
                <VStack align="flex-start" gap={1} flex={1}>
                    <Text fontSize="lg" fontWeight="bold" color="black">
                        {room.name}
                    </Text>
                    <HStack gap={2} align="center">
                        <Icon as={FiUsers} boxSize={4} color="gray.600" />
                        <Text fontSize="sm" color="gray.600">
                            {t.pages.office.capacity}: {room.capacity} {t.pages.office.people}
                        </Text>
                    </HStack>
                </VStack>
            </HStack>
        </Box>
    );
};

export default MeetingRoomPreview;
